module.exports = __webpack_public_path__ + "static/p-0311620e3e8557921033f85cc6d85e06.ico";